import React, { lazy } from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Calendar, MapPin, Clock, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Events = () => {
  const upcomingEvents = [{
    title: 'Networking Salon - Warri Edition',
    date: 'August 30, 2025',
    location: 'Warri, Nigeria',
    time: '4:00 PM - 7:00 PM',
    description: 'Join us for an evening of meaningful connections, inspiring conversations, and opportunities in Warri.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1BbFm8kmubumv56AGcAZxq/1755202597061.jpg',
    link: '/events/warri-2025'
  }, {
    title: 'Berlin Creative Salon',
    date: 'September 15, 2025',
    location: 'Berlin, Germany',
    time: '6:00 PM - 9:00 PM',
    description: "Connect with Berlin's creative community in this special edition of The Networking Salon.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiXQQAf7xCj7Df9afZdc12/five_ladies.jpg'
  }, {
    title: 'Lagos Tech Meetup',
    date: 'October 5, 2025',
    location: 'Lagos, Nigeria',
    time: '4:00 PM - 7:00 PM',
    description: 'A focused networking event for tech professionals, entrepreneurs, and innovators in Lagos.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kuYFBEnx6pGWYjXhvRTywy/Four_uke.jpg'
  }, {
    title: 'Benin City Salon',
    date: 'November 10, 2025',
    location: 'Benin City, Nigeria',
    time: '3:00 PM - 6:00 PM',
    description: 'Expanding our community in Benin City with this special networking event for professionals and changemakers.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aftEvNay6iufkLwXy7PyxK/1755202597036.jpg'
  }];
  return <div className="pt-20" data-id="element-2931" data-mp="5p5hhzanzn3n">
      <section className="py-16 bg-secondary/5" data-id="element-2932" data-mp="5nuisdw2t5je">
        <div className="container mx-auto px-4" data-id="element-2933" data-mp="5n2tfkt2o41k">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-2934" data-mp="vbzsuvvg3tps">
            Upcoming Events
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-2935" data-mp="zctlu3nqvypj">
            Join us at one of our upcoming networking salons around the world.
            Connect with professionals, share ideas, and discover new
            opportunities.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-2936" data-mp="cg019m6dqs6q">
        <div className="container mx-auto px-4" data-id="element-2937" data-mp="gfs9fxrv2wbk">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-2938" data-mp="ggai5tvpn30d">
            {upcomingEvents.map((event, index) => <Card key={index} className="flex flex-col" data-id="element-2939" data-mp="qdyciipem8i0" data-mpi={index}>
                <div className="relative aspect-[16/9] border-2 border-gray-300 mb-4 overflow-hidden" data-id="element-2940" data-mp="qfj728bpxrfv">
                  <img src={event.image} alt={event.title} className="w-full h-full object-cover" loading="lazy" data-id="element-2941" data-mp="1wtim3sx1qswt" />
                </div>
                <h3 className="text-xl font-bold text-secondary-dark" data-id="element-2942" data-mp="3hc2qywwk03ye">
                  {event.title}
                </h3>
                <p className="text-secondary mt-2 mb-4" data-id="element-2943" data-mp="3ckulgbych2qi">{event.description}</p>
                <div className="mt-auto space-y-2" data-id="element-2944" data-mp="37m9kubf6kh1j">
                  <div className="flex items-center" data-id="element-2945" data-mp="37lqabfrv0uxj">
                    <Calendar size={18} className="mr-2 text-primary" data-id="element-2946" data-mp="33keeutmb1fhf" />
                    <span data-id="element-2947" data-mp="33ibi7qqnco3q">{event.date}</span>
                  </div>
                  <div className="flex items-center" data-id="element-2948" data-mp="2yk07zewfwbkz">
                    <MapPin size={18} className="mr-2 text-primary" data-id="element-2949" data-mp="2tm8ewhk26jf7" />
                    <span data-id="element-2950" data-mp="2tokz71dah5vf">{event.location}</span>
                  </div>
                  <div className="flex items-center" data-id="element-2951" data-mp="2ooyj8k62tbix">
                    <Clock size={18} className="mr-2 text-primary" data-id="element-2952" data-mp="ruvd41de0rnd" />
                    <span data-id="element-2953" data-mp="rt10rbg6m7uw">{event.time}</span>
                  </div>
                  <div className="mt-4" data-id="element-2954" data-mp="mxbzn3oikiwh">
                    {event.link ? <Link to={event.link} data-id="element-2955" data-mp="uwgohlep1ntg">
                        <Button variant="outline" className="w-full" data-id="element-2956" data-mp="uundxv0ymjg6">
                          View Details
                        </Button>
                      </Link> : <Button variant="outline" className="w-full" data-id="element-2957" data-mp="l0n2zcizyjzj">
                        RSVP
                      </Button>}
                  </div>
                </div>
              </Card>)}
          </div>
          <div className="border-2 border-gray-300 rounded-lg overflow-hidden" data-id="element-2958" data-mp="gxh10h2x3eyv">
            <div className="p-4 bg-secondary/5 border-b border-gray-300" data-id="element-2959" data-mp="282r97vfiviy">
              <h2 className="text-xl font-bold text-secondary-dark flex items-center" data-id="element-2960" data-mp="25ybnso6482u">
                <Calendar size={20} className="mr-2" data-id="element-2961" data-mp="77fazjr07mhb" />
                Event Calendar
              </h2>
            </div>
            <div className="p-4" data-id="element-2962" data-mp="3pf4qrcz5qu46">
              <iframe src="https://calendar.google.com/calendar/embed?src=socialnetworkingimmersion%40gmail.com&ctz=Africa%2FLagos" style={{
              border: 0
            }} width="100%" height="600" frameBorder="0" scrolling="no" className="border border-gray-200 rounded" data-id="element-2963" data-mp="3tevra8ehkolw"></iframe>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-2964" data-mp="3etrn3yedhyef">
            <p className="text-secondary mb-6" data-id="element-2965" data-mp="3to4hb5znkhir">
              Want to host a Networking Salon in your city? Become a city lead
              and help build our community.
            </p>
            <Button data-id="element-2966" data-mp="6cdahpi2wvxe">Become a City Lead</Button>
          </div>
        </div>
      </section>
    </div>;
};